(function() {
  var STORE_KEY = 'vp_store';
  var variantNameToId = {};
  var styleEl = null;

  function buildVariantMap() {
    var parts = window.location.pathname.split('/products/');
    if (parts.length < 2) return Promise.resolve();
    var handle = parts[1].split('?')[0].split('#')[0];
    if (!handle) return Promise.resolve();
    return fetch('/products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        d.variants.forEach(function(v) {
          variantNameToId[v.option1] = String(v.id);
        });
      })
      .catch(function() {});
  }

  function getStyleEl() {
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'vp-variant-styles';
      document.head.appendChild(styleEl);
    }
    return styleEl;
  }

  function initPopup() {
    var popup = document.getElementById('store-selector-popup');
    if (!popup) return;

    var hasStore = localStorage.getItem(STORE_KEY);
    var seenThisSession = sessionStorage.getItem('vp_session');

    if (!hasStore || !seenThisSession) {
      popup.classList.add('vp-active');
    }

    popup.querySelectorAll('.store-btn[data-store]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        localStorage.setItem(STORE_KEY, btn.getAttribute('data-store'));
        sessionStorage.setItem('vp_session', '1');
        popup.classList.remove('vp-active');
        updateStockDisplay();
        updateVariantAvailability();
        setTimeout(addChangeSucursalBtn, 400);
      });
    });
  }

  function getOrCreateStockEl() {
    var el = document.getElementById('vp-stock-display');
    if (!el) {
      el = document.createElement('div');
      el.id = 'vp-stock-display';
      el.style.cssText = 'margin:10px 0;font-size:14px;font-weight:600;padding:8px 14px;border-radius:8px;display:inline-block;';
      var targets = ['.product-form__buttons','.product-form','[data-product-form]','form[action*="/cart/add"]','.product__info-container','main'];
      for (var i = 0; i < targets.length; i++) {
        var t = document.querySelector(targets[i]);
        if (t) { t.insertAdjacentElement('beforebegin', el); break; }
      }
    }
    return el;
  }

  function showStock(qty, store) {
    if (!document.querySelector('.product-form, [data-product-form], form[action*="/cart/add"]')) return;
    var el = getOrCreateStockEl();
    if (qty === null || qty === undefined) {
      el.style.background = '#f5f5f5'; el.style.color = '#888';
      el.textContent = 'Selecciona tu sucursal para ver el stock';
    } else if (qty <= 0) {
      el.style.background = '#fff0f0'; el.style.color = '#c8283c';
      el.textContent = 'Sin stock en sucursal ' + store;
    } else if (qty <= 3) {
      el.style.background = '#fff8e1'; el.style.color = '#e65100';
      el.textContent = 'Ultimas ' + qty + ' unidades en ' + store;
    } else {
      el.style.background = '#f0fff4'; el.style.color = '#2e7d32';
      el.textContent = 'Disponible en ' + store + ': ' + qty + ' unidades';
    }
  }

  function getCurrentVariantId() {
    var sel = document.querySelector('[name="id"]');
    if (sel) return sel.value;
    return new URL(window.location.href).searchParams.get('variant');
  }

  function getStockForVariant(variantId, store) {
    var meta = window.vpVariantMeta;
    if (!meta || !meta[variantId]) return null;
    var v = meta[variantId];
    if (store === 'Rosario') {
      return (v.stock_rosario !== undefined && v.stock_rosario !== null) ? parseInt(v.stock_rosario) : null;
    } else if (store === 'San Nicolas') {
      return (v.stock_san_nicolas !== undefined && v.stock_san_nicolas !== null) ? parseInt(v.stock_san_nicolas) : null;
    }
    return null;
  }

  function updateStockDisplay() {
    var store = localStorage.getItem(STORE_KEY);
    if (!store || !window.location.pathname.includes('/products/')) return;
    var variantId = getCurrentVariantId();
    if (!variantId) return;
    var qty = getStockForVariant(variantId, store);
    if (qty !== null) {
      showStock(qty, store);
    } else {
      fetch('/variants/' + variantId + '.js')
        .then(function(r) { return r.json(); })
        .then(function(d) {
          showStock(store === 'Rosario' ? d.inventory_quantity : 0, store);
        })
        .catch(function() { showStock(null, store); });
    }
  }

  function updateVariantAvailability() {
    var store = localStorage.getItem(STORE_KEY);
    if (!store || !window.location.pathname.includes('/products/')) return;
    var meta = window.vpVariantMeta;
    if (!meta || Object.keys(variantNameToId).length === 0) return;

    var outOfStockIds = [];
    var inStockIds = [];

    document.querySelectorAll('input[type="radio"]').forEach(function(input) {
      var variantId = variantNameToId[input.value];
      if (!variantId) return;
      var qty = getStockForVariant(variantId, store);
      if (qty === null) return;

      if (qty <= 0) {
        outOfStockIds.push(input.id);
      } else {
        inStockIds.push(input.id);
      }
    });

    var css = '';
    outOfStockIds.forEach(function(id) {
      css += 'label[for="' + id + '"] { opacity: 0.35 !important; text-decoration: line-through !important; cursor: not-allowed !important; pointer-events: none !important; }\n';
      css += '#' + id + ' { pointer-events: none !important; }\n';
    });
    inStockIds.forEach(function(id) {
      css += 'label[for="' + id + '"] { opacity: 1 !important; text-decoration: none !important; cursor: pointer !important; pointer-events: auto !important; border-color: #ffffff !important; color: #ffffff !important; }\n';
      css += 'input#' + id + ':checked ~ label[for="' + id + '"] { color: #000000 !important; }\n';
    });

    var fieldset = document.querySelector('fieldset.product-form__input-pill, fieldset');
    if (fieldset) {
      css += 'fieldset.product-form__input-pill, fieldset { display: flex !important; flex-wrap: wrap !important; }\n';
      inStockIds.forEach(function(id) {
        css += 'label[for="' + id + '"] { order: 1 !important; }\n';
      });
      outOfStockIds.forEach(function(id) {
        css += 'label[for="' + id + '"] { order: 2 !important; }\n';
      });
    }

    getStyleEl().textContent = css;
  }

  function watchVariantChanges() {
    document.addEventListener('click', function(e) {
      var label = e.target.closest('label');
      if (label && label.closest('variant-selects, fieldset')) {
        setTimeout(function() {
          updateStockDisplay();
          updateVariantAvailability();
        }, 150);
      }
    });

    document.addEventListener('change', function(e) {
      if (e.target && e.target.type === 'radio') {
        setTimeout(function() {
          updateStockDisplay();
          updateVariantAvailability();
        }, 100);
      }
    });

    document.addEventListener('variant:change', function() {
      setTimeout(function() {
        updateStockDisplay();
        updateVariantAvailability();
      }, 100);
    });

    var last = getCurrentVariantId();
    setInterval(function() {
      var cur = getCurrentVariantId();
      if (cur !== last) { last = cur; updateStockDisplay(); }
    }, 500);
  }

  function addChangeSucursalBtn() {
    if (!window.location.pathname.includes('/products/')) return;
    if (document.getElementById('vp-change-store-btn')) return;
    var btn = document.createElement('button');
    btn.id = 'vp-change-store-btn';
    btn.type = 'button';
    btn.textContent = 'Cambiar sucursal';
    btn.style.cssText = 'background:none;border:1px solid #ccc;border-radius:6px;padding:4px 10px;font-size:12px;cursor:pointer;margin-left:8px;color:#555;';
    btn.addEventListener('click', function() {
      localStorage.removeItem(STORE_KEY);
      sessionStorage.removeItem('vp_session');
      var popup = document.getElementById('store-selector-popup');
      if (popup) popup.classList.add('vp-active');
    });
    setTimeout(function() {
      var stockEl = document.getElementById('vp-stock-display');
      if (stockEl) stockEl.insertAdjacentElement('afterend', btn);
    }, 300);
  }

  function init() {
    initPopup();
    if (window.location.pathname.includes('/products/')) {
      var attempts = 0;
      function tryInit() {
        attempts++;
        if (window.vpVariantMeta || attempts > 20) {
          buildVariantMap().then(function() {
            updateStockDisplay();
            updateVariantAvailability();
            watchVariantChanges();
            setTimeout(addChangeSucursalBtn, 400);
          });
        } else {
          setTimeout(tryInit, 100);
        }
      }
      tryInit();
    }
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
